/* src/app/groups/presenters/groups-presenters.component.scss */
.groups-panels > [class*=col-] {
  min-width: 0;
}
.groups-table-host {
  width: 100%;
  min-width: 0;
}
:host ::ng-deep .groups-panels .p-panel,
:host ::ng-deep .groups-panels .p-panel-content {
  min-width: 0;
}
:host ::ng-deep .groups-table .p-datatable-table-container,
body#themeTag :host ::ng-deep .groups-table .p-datatable-table-container {
  overflow: auto;
}
:host ::ng-deep .groups-table .p-datatable-table,
body#themeTag :host ::ng-deep .groups-table .p-datatable-table {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100% !important;
}
:host ::ng-deep .groups-table .p-datatable-thead > tr > th,
:host ::ng-deep .groups-table .p-datatable-tbody > tr > td,
body#themeTag :host ::ng-deep .groups-table .p-datatable-thead > tr > th,
body#themeTag :host ::ng-deep .groups-table .p-datatable-tbody > tr > td {
  padding: 0.35rem 0.5rem;
  white-space: nowrap;
  vertical-align: middle;
}
:host ::ng-deep .groups-table .p-datatable-tbody > tr > td,
body#themeTag :host ::ng-deep .groups-table .p-datatable-tbody > tr > td {
  overflow: hidden;
}
:host ::ng-deep .groups-table .groups-col-header-tight,
body#themeTag :host ::ng-deep .groups-table .groups-col-header-tight {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 0.15rem !important;
  padding-right: 0.15rem !important;
}
:host ::ng-deep .groups-table .groups-col-name,
body#themeTag :host ::ng-deep .groups-table .groups-col-name {
  min-width: 12rem !important;
}
:host ::ng-deep .groups-table td.groups-col-name,
body#themeTag :host ::ng-deep .groups-table td.groups-col-name {
  overflow: hidden;
  text-overflow: ellipsis;
}
:host ::ng-deep .groups-table .groups-col-action,
body#themeTag :host ::ng-deep .groups-table .groups-col-action {
  min-width: 8rem !important;
}
:host ::ng-deep .groups-table .groups-col-check,
body#themeTag :host ::ng-deep .groups-table .groups-col-check {
  min-width: 6.5rem !important;
  text-align: center;
}
:host ::ng-deep .groups-table .groups-col-action .p-button,
body#themeTag :host ::ng-deep .groups-table .groups-col-action .p-button {
  white-space: nowrap;
}
:host ::ng-deep .groups-table .groups-cell-center,
body#themeTag :host ::ng-deep .groups-table .groups-cell-center {
  text-align: center !important;
}
:host ::ng-deep .groups-table .groups-cell-flex-center,
body#themeTag :host ::ng-deep .groups-table .groups-cell-flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
:host ::ng-deep .groups-table .groups-cell-flex-center .p-checkbox,
body#themeTag :host ::ng-deep .groups-table .groups-cell-flex-center .p-checkbox {
  display: inline-flex;
}
:host ::ng-deep .groups-table .groups-member-assign-toggle,
body#themeTag :host ::ng-deep .groups-table .groups-member-assign-toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.groups-unused-admin-slots-banner {
  width: 100%;
}
.groups-unused-admin-slots-banner .p-message {
  margin: 0;
}
.groups-admin-license-notice {
  padding: 0.875rem 1rem;
  border-radius: var(--border-radius, 6px);
  border: 1px solid var(--p-blue-200, #bfdbfe);
  border-left-width: 4px;
  border-left-color: var(--p-primary-color, #3b82f6);
  background: var(--p-blue-50, #eff6ff);
  color: var(--p-text-color, #334155);
}
.groups-admin-license-notice__line {
  margin: 0;
  line-height: 1.5;
  color: var(--p-text-color, #334155);
}
.groups-admin-license-notice__line + .groups-admin-license-notice__line {
  margin-top: 0.25rem;
}
.groups-admin-license-notice__line .font-medium {
  color: inherit !important;
}
.groups-admin-license-notice__cta {
  color: var(--p-text-muted-color, #64748b);
}
.groups-admin-license-notice__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
}
html.app-dark .groups-admin-license-notice {
  border-color: var(--p-blue-700, #1d4ed8);
  border-left-color: var(--p-primary-color, #60a5fa);
  background: rgba(59, 130, 246, 0.12);
  color: var(--p-text-color, #e2e8f0);
}
html.app-dark .groups-admin-license-notice__line {
  color: var(--p-text-color, #e2e8f0);
}
html.app-dark .groups-admin-license-notice__cta {
  color: var(--p-text-muted-color, #94a3b8);
}
/*# sourceMappingURL=groups-presenters.component.css.map */
